import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import { url } from "inspector";

export const promoCodeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPromoCodes: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/promo-code"),
      }),
      providesTags: ["PromoCodes"],
    }),
    getPromoCode: builder.query<any, string>({
      query: (id) => ({
        url: `/api/promo-code/${id}`,
      }),
      providesTags: ["PromoCode"],
    }),
    addPromoCode: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/promo-code",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PromoCodes", "PromoCode"],
    }),
    updatePromoCode: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/promo-code/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["PromoCodes", "PromoCode"],
    }),
    deletePromoCode: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/promo-code/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PromoCodes"],
    }),
  }),
});

export const {
  useGetPromoCodesQuery,
  useGetPromoCodeQuery,
  useAddPromoCodeMutation,
  useUpdatePromoCodeMutation,
  useDeletePromoCodeMutation,
} = promoCodeApi;
